import {
  AfterViewInit,
  Directive,
  ElementRef,
  inject,
  input,
  OnDestroy,
} from '@angular/core';
import { OverlayPosition, OverlayRole } from './overlay.types';
import { OverlayService } from './overlay.service';

@Directive({
  selector: '[fcOverlay]',
  standalone: true,
  host: {
    popover: 'manual',
    class: 'fc-overlay',
    '[attr.data-position]': 'position()',
    '[attr.role]': 'role()',
  },
})
export class OverlayContentDirective implements AfterViewInit, OnDestroy {
  private elementRef = inject(ElementRef<any>);
  private overlayService = inject(OverlayService);
  private overlayId?: string;

  fcOverlay = input.required<any>();
  role = input<OverlayRole>('menu');
  position = input<OverlayPosition>('bottom');

  ngAfterViewInit(): void {
    const element = this.elementRef.nativeElement;
    const trigger = this.fcOverlay();
    if (trigger.overlayId) {
      this.overlayId = trigger.overlayId;
    } else if (typeof trigger.getAttribute === 'function') {
      this.overlayId =
        trigger.getAttribute('data-overlay-trigger') ?? undefined;
    }

    if (this.overlayId) {
      element.id = this.overlayId;
      element.style.positionAnchor = `--${this.overlayId}`;
      this.overlayService.register(this.overlayId, element);
    }
  }

  ngOnDestroy(): void {
    if (this.overlayId) {
      this.overlayService.unregister(this.overlayId);
    }
  }
}
